// ============================================================
// document.js
// ------------------------------------------------------------
// ตัวช่วยเปิดหน้าเอกสาร (ใบเสร็จ / ใบแจ้งหนี้ / จดหมาย) ในแท็บใหม่
//
// วิธีส่งข้อมูลของระบบนี้: เขียนลง localStorage คีย์ "DATA_" แล้วเปิดหน้าเอกสาร
// หน้าเอกสารใน src/document/* จะอ่านคีย์นี้ไป render เป็น PDF
// เดิมโค้ด 2 บรรทัดนี้ถูก copy อยู่หลายหน้า พร้อมกับการประกอบหัวกระดาษที่เขียนซ้ำกัน
// ============================================================

import { getStorage } from "../core/storage.js";
import { format_date } from "../core/format.js";

// หัวกระดาษ: ที่อยู่โครงการ + เบอร์โทร + เลขผู้เสียภาษี
export const projectAddressBlock = () => `เลขที่ ${getStorage("project_address")}\nเบอร์โทรติดต่อ ${getStorage("phone_number")} เลขที่ผู้เสียภาษี ${getStorage("tax_number")}`;

// เปิดหน้าเอกสารในแท็บใหม่ พร้อมส่งข้อมูลผ่าน localStorage
export const openDocument = (path, data) => {
  localStorage.setItem("DATA_", JSON.stringify(data));
  window.open(path, "_blank");
};

// ข้อมูลสำหรับเอกสาร "ใบแจ้งหนี้อื่น ๆ" (/doc/invoice-other)
// ใช้ร่วมกันระหว่างหน้าออกใบแจ้งหนี้ (RecordBill) และหน้าประวัติ (RecordBillHistory)
// NOTE ชื่อคีย์ cutomer_name / cutomer_address สะกดผิดมาแต่เดิม
// หน้าเอกสารอ่านคีย์นี้อยู่ ถ้าจะแก้ต้องแก้พร้อมกันทั้ง src/document/InvoiceOther.js
export const buildInvoiceOtherData = ({ full_name, address, iw_number, record_date, title, description, cost }) => ({
  project_name: getStorage("project_name"),
  project_address: projectAddressBlock(),
  // NOTE cutomer_* สะกดผิดมาแต่เดิม — ส่งชื่อที่ถูก (customer_*) ควบคู่ไปด้วย
  cutomer_name: full_name,
  cutomer_address: address,
  customer_name: full_name,
  customer_address: address,
  number: iw_number,
  date: format_date(record_date, "dd mmmm yyyy"),
  payment_date: format_date(record_date, "dd mmmm yyyy"),
  title,
  description,
  cost,
  total: cost,
  change_satang: 0,
});
